import { useEffect } from "react";

const BASE_URL = "https://emergenciaanimal.org";
const DEFAULT_IMAGE = `${BASE_URL}/logos/logo-emergencia-animal.png`;
const SITE_NAME = "Emergencia Animal";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function SEO({ title, description, path = "/", image, type = "website", article, breadcrumbs, noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Protección Animal en Emergencias`;
  const url = `${BASE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  const desc = description || "";

  useEffect(() => {
    document.title = fullTitle;

    setMeta("name", "description", desc);
    setLink("canonical", url);

    if (noindex) {
      setMeta("name", "robots", "noindex,nofollow");
    }

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:locale", "es_ES");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);

    if (article) {
      setJsonLd("seo-article-ld", {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title || "",
        description: desc,
        datePublished: article.date || "",
        dateModified: article.date || "",
        author: { "@type": "Organization", name: SITE_NAME, url: BASE_URL },
        publisher: {
          "@type": "Organization",
          name: SITE_NAME,
          logo: { "@type": "ImageObject", url: DEFAULT_IMAGE },
        },
        mainEntityOfPage: url,
        inLanguage: "es",
        keywords: (article.keywords || []).join(", "),
      });
    }

    if (breadcrumbs && breadcrumbs.length > 0) {
      setJsonLd("seo-breadcrumb-ld", {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((bc, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: bc.name,
          item: bc.url ? `${BASE_URL}${bc.url}` : undefined,
        })),
      });
    }

    return () => {
      const ld = document.getElementById("seo-article-ld");
      if (ld) ld.remove();
      const bc = document.getElementById("seo-breadcrumb-ld");
      if (bc) bc.remove();
    };
  }, [fullTitle, desc, url, type, img, noindex, article, breadcrumbs]);

  return null;
}
